define('lq/events/actions/copyDynamicContentCommand',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function CopyDynamicContentCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(CopyDynamicContentCommand, EventAction);

    CopyDynamicContentCommand.typeName = 'CopyDynamicContentCommand';

    CopyDynamicContentCommand.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    CopyDynamicContentCommand.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'CopyDynamicContent',
            command: this.eventData.command
        };
    };

    CopyDynamicContentCommand.prototype.execute = function (continuation, eventActionResponse) {
        continuation();
    };

    CopyDynamicContentCommand.prototype.handleError = function (eventName, defaultMessage, continuation) {
        if (this.eventIsEnabled(eventName)) {
            this.triggerEvent(eventName, continuation);
        } else {
            alert(defaultMessage);
            continuation();
        }
    };

    return CopyDynamicContentCommand;
});
